import { Grid } from '@mui/material'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'
import styles from './MarketSpyGrid.module.css'

interface MarketSpyGridProps {
    marketSpy: any
}

export const MarketSpyGrid = (props: MarketSpyGridProps): JSX.Element => {
    const {
        marketSpy
    } = props

    return (
        <div>
            <div className={styles.MarketSpyGrid_PropertyListContainer}>
                <div className={styles.MarketSpyGrid_NamePropStyle}>
                    Location:
                </div>
                <div className={styles.MarketSpyGrid_ValuePropStyle}>
                    {`${marketSpy?.locations?.join(', ')}`}
                </div>
                <div className={styles.MarketSpyGrid_NamePropStyle}>
                    Platforms:
                </div>
                <div className={styles.MarketSpyGrid_ValuePropStyle}>
                    {`AirBnb`}
                </div>
                <div className={styles.MarketSpyGrid_NamePropStyle}>
                    Bedrooms:
                </div>
                <div className={styles.MarketSpyGrid_ValuePropStyle}>
                    {marketSpy?.bedrooms ? marketSpy.bedrooms : 'any'}
                </div>
                <div className={styles.MarketSpyGrid_NamePropStyle}>
                    Beds:
                </div>
                <div className={styles.MarketSpyGrid_ValuePropStyle}>
                    {marketSpy?.Beds ? marketSpy.Beds : 'any'}
                </div>
                <div className={styles.MarketSpyGrid_NamePropStyle}>
                    Pets:
                </div>
                <div className={styles.MarketSpyGrid_ValuePropStyle}>
                    {marketSpy?.pets}
                </div>
            </div>

            <Grid container sx={{ p: '16px' }}>
                <Grid item xs={12}>
                    <div>
                        <Link to={`/spy/${marketSpy?.id}`}>
                            <Button
                                color="success"
                                size="small"
                                variant="contained"
                                sx={{
                                    minWidth: {
                                        sx: 70,
                                        md: 110
                                    }
                                }}
                            >
                                Edit
                            </Button >
                        </Link>
                    </div>
                </Grid>
            </Grid>
        </div>     
    )
}